import { Base } from './_base.model';

export class StaticContent extends Base {
  id: string;
  title: string;
  content: string;
  web_url: string;
  archived: boolean;
}
